import Footer from './Footer';
import Player from './Player';
import GameMaster from './GameMaster';

export default { Footer, Player, GameMaster };
